import { render, staticRenderFns } from "./ProductTypesList.vue?vue&type=template&id=f226ff7e&"
import script from "./ProductTypesList.vue?vue&type=script&lang=js&"
export * from "./ProductTypesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports